import ChatMessageCounter from './ChatMessageCounter';

export default ChatMessageCounter;
